import { type InjectionKey } from "vue";
import { AxiosInstance } from "axios";

/**
 * axiosを使用するためのキー
 */
export const AXIOS_KEY: InjectionKey<AxiosInstance> = Symbol("axios");
